import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { IconComponent } from '@mode/capra';
import {
  ScheduleModalFacade,
  ScheduleOwnerFacade,
  ScheduleResource,
  ScheduleSlackFacade,
  ScheduleSubscriptionFacade,
} from '@mode/shared/schedules/contract';
import { CadenceConfigComponent, DeliveryComponent, ParametersComponent } from '@mode/shared/schedules/ui';
import {
  EmailSettingsComponent,
  HeaderComponent,
  LoaderComponent,
  SlackChannelSelectorComponent,
} from '@mode/shared/ui';
import { HelpDocsService } from '@mode/shared/util-js';
import { ThoughtspotIntegrationService } from '@mode/shared/util-thoughtspot-integrated';
import { DataViewFacade } from '@mode/switch-views/contract';
import { NoticesScrolling, SCROLL_SERVICE, ScrollService } from '../scroll-service';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    CadenceConfigComponent,
    DeliveryComponent,
    HeaderComponent,
    IconComponent,
    LoaderComponent,
    EmailSettingsComponent,
    ParametersComponent,
    SlackChannelSelectorComponent,
  ],
  providers: [
    {
      provide: SCROLL_SERVICE,
      useClass: ScrollService,
    },
  ],
  selector: 'mode-schedule-editor-container',
  templateUrl: './schedule-editor-container.component.html',
  styleUrls: ['./schedule-editor-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleEditorContainerComponent {
  public thoughtSpotIntegrated$ = this.thoughtspotIntegrationService.currOrgIntegrated$;

  constructor(
    public dataViewFacade: DataViewFacade,
    public scheduleOwnerFacade: ScheduleOwnerFacade,
    public scheduleModalFacade: ScheduleModalFacade,
    public scheduleSubscriptionFacade: ScheduleSubscriptionFacade,
    public scheduleSlackFacade: ScheduleSlackFacade,
    @Inject(SCROLL_SERVICE) public scrollService: NoticesScrolling,
    public helpDocs: HelpDocsService,
    private thoughtspotIntegrationService: ThoughtspotIntegrationService
  ) {}

  @Input() scheduleEditContainerInputs = {
    schedule: {} as unknown as ScheduleResource,
    email: 'test@test.com',
    isDataset: false,
    showScheduleEditForm: false,
    notifyType: 'none',
    param: {
      defaultOptions: [],
      options: [],
      selectedParams: {},
    },
    paramsExist: false,
    reportParameterOptionsLoading: false,
    reportParameterOptionsComplete: false,
    slackDeliveryOptionEnabled: false,
    subscription: {
      data_previews_enabled: false,
      data_tables_enabled: false,
      csv_attachments_enabled: false,
      pdf_attachments_enabled: false,
      report_links_enabled: false,
    },
  };

  @Output() dayOfMonthChanged = new EventEmitter<number>();
  @Output() dayOfWeekChanged = new EventEmitter<number>();
  @Output() startTimeChanged = new EventEmitter<number>();
  @Output() timeChanged = new EventEmitter<any>();
  @Output() deliveryTypeChanged = new EventEmitter<any>();
  @Output() testEmail = new EventEmitter<void>();
  @Output() updateParam = new EventEmitter<any>();
  @Output() updateMultiSelectAngular = new EventEmitter<any>();

  onScroll(event: { target: Element }) {
    const bottomSection = event.target.querySelector('[data-id="bottom-section"]');

    if (bottomSection !== null) {
      this.scrollService.upperElementScrolled(bottomSection);
    }
  }
}
